import React, { useMemo } from 'react';

import { TableCell, TableRow } from '@occc/ui-design-system';
import { OpenCommerceUserFragment } from '@occc/graphql';
import { getPersonFullName } from '@occc-app/lib/person';

import { userStatusMap } from './constants';
import { UsersActionsContainer } from './UsersActionsContainer';

import { userRoleMap } from '../constants';

type UsersTableRowProps = {
  user: OpenCommerceUserFragment;
};

export const UsersTableRow = ({ user }: UsersTableRowProps) => {
  const { name, email, userRole, status, uuid } = user;
  const userPersonFullName = useMemo(() => getPersonFullName(name), [name]);

  return (
    <>
      <TableRow>
        <TableCell>{userPersonFullName}</TableCell>
        <TableCell>{email || 'No email defined'}</TableCell>
        <TableCell>{userRoleMap[userRole] || 'No role defined'}</TableCell>
        <TableCell>{userStatusMap[status] || 'No status defined'}</TableCell>
        <TableCell padding='button' align='right'>
          <UsersActionsContainer
            uuid={uuid}
            userPersonFullName={userPersonFullName}
            status={status}
            email={email}
          />
        </TableCell>
      </TableRow>
    </>
  );
};
